var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#F5F8FA",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 21C8.58172 21 5 17.4183 5 13C5 8.58172 8.58172 5 13 5C17.4183 5 21 8.58172 21 13C21 17.4183 17.4183 21 13 21ZM13 19.7692C16.7386 19.7692 19.7692 16.7385 19.7692 13C19.7692 9.26145 16.7386 6.23076 13 6.23076C9.26146 6.23076 6.23078 9.26145 6.23078 13C6.23078 16.7385 9.26146 19.7692 13 19.7692ZM10.9077 11.3487C10.9077 11.1555 10.9597 10.9657 11.0583 10.7995C11.3617 10.2879 12.0223 10.1191 12.5339 10.4224L15.815 12.3682C15.9703 12.4602 16.1 12.5899 16.192 12.7452C16.4954 13.2567 16.3266 13.9174 15.815 14.2208L12.5339 16.1665C12.3676 16.2651 12.1779 16.3171 11.9846 16.3171C11.3898 16.3171 10.9077 15.8349 10.9077 15.2402V11.3487ZM12.1385 14.9701L14.9641 13.2945L12.1385 11.6189V14.9701Z",
    fill: "#353F45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "assets/media/Video.af09cbd4.svg";
export { ForwardRef as ReactComponent };